<template>
  <b-container class="page-container">
    <Breadcrumbs currentpage="Nieuw wachtwoord instellen" />
    <h1>Nieuw wachtwoord instellen</h1>
    <b-alert v-if="invalidLink || !code" show variant="warning"
      ><font-awesome-icon icon="exclamation-circle" /> Je wachtwoord herstel
      link lijkt onjuist of verlopen, je wachtwoord is niet aangepast. Vraag
      opnieuw een
      <router-link :to="{ name: 'forgotPassword' }"
        >nieuw wachtwoord</router-link
      >
      aan.
    </b-alert>

    <p v-if="!invalidLink && code">
      Vul hieronder je nieuwe wachtwoord in
    </p>

    <b-row v-if="!invalidLink && code">
      <b-col sm="12" class="mb-3"></b-col>
      <b-col cols="12">
        <hr />
        <b-form-text id="password-help-block">
          <p>Een nieuwe wachtwoord moet:</p>
          <ul>
            <li>- Minimaal 8 karakters zijn.</li>
            <li>- Met minimaal één hoofdletter. A t/m Z.</li>
            <li>- Met minimaal één kleine letter. a t/m z.</li>
            <li>
              - Met minimaal één cijfer. 0 t/m 9.
            </li>
            <li>- Met minimaal één speciale teken zoals !@#$%&</li>
          </ul>
        </b-form-text>
      </b-col>

      <b-col sm="12" md="6" lg="4">
        <b-card>
          <b-form @submit.prevent="resetPasswordSubmit">
            <b-form-group
              id="input-group-1"
              label="Nieuwe wachtwoord"
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                v-model="form.password"
                type="password"
                :state="passwordValidation"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-1"
              label="Herhaal nieuwe wachtwoord"
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                v-model="form.confirmPassword"
                type="password"
                required
                :state="passwordConfirmState && passwordValidation"
              ></b-form-input>
            </b-form-group>
            <b-row>
              <b-col cols="12">
                <b-button
                  class="mb-2"
                  type="submit"
                  :disabled="!passwordConfirmState || !passwordValidation"
                  variant="primary"
                  >Wachtwoord wijzigen
                  <font-awesome-icon
                    v-if="requesting"
                    class="fa-spin"
                    far
                    icon="spinner"
                /></b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { setNewPassword } from '@/services/AuthorizationService'
import Breadcrumbs from '@/components/header/BreadCrumbs'
export default {
  components: { Breadcrumbs },
  data() {
    return {
      form: {
        password: '',
        confirmPassword: ''
      },
      invalidLink: false,
      success: false,
      requesting: false,
      wrongPassword: false
    }
  },
  computed: {
    code: function() {
      return this.$route.query.code || false
    },
    passwordValidation() {
      let password = this.form.password
      if (password != '') {
        if (password.length < 8) {
          return false
        }

        var numberRegex = /[0-9]/g
        if (!password.match(numberRegex)) {
          return false
        }

        const lowercaseRegex = /[a-z]/g
        if (!password.match(lowercaseRegex)) {
          return false
        }

        const capitalRegex = /[A-Z]/g
        if (!password.match(capitalRegex)) {
          return false
        }

        const symbolRegex = /[!|@|#|$|%|&]/g
        if (!password.match(symbolRegex)) {
          return false
        }

        return true
      }

      return null
    },

    passwordConfirmState() {
      if (this.form.password != '') {
        if (this.form.password == this.form.confirmPassword) {
          return true
        }
        return false
      }
      return null
    }
  },
  watch: {
    form: {
      handler() {
        if (this.form.password != this.confirmPassword) {
          this.wrongPassword = true
        } else {
          this.wrongPassword = false
        }
      },
      deep: true
    }
  },
  methods: {
    async resetPasswordSubmit() {
      this.requesting = true

      const result = await setNewPassword({
        password: this.form.password,
        confirmPassword: this.form.confirmPassword,
        code: this.code
      })

      if (
        result.data != null &&
        result.data != 'FAILURE' &&
        result.data == 'SUCCESS'
      ) {
        this.success = true
        this.$router.push({ name: 'login', query: { passwordReset: true } })
      } else {
        this.invalidLink = true
      }

      this.requesting = false
    }
  }
}
</script>
<style scoped lang="scss">
a.btn {
  text-decoration: none;
}
a {
  font-family: 'DecimaPro-bold';
}
</style>
